import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const optionsStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 30,
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#F2F2F2',
      [theme.breakpoints.down('xs')]: {
        padding: 5,
        boxSizing: 'border-box',
        width: '100%',
      },
    },
    box: {
      borderBottom: '0.5px solid #fcb51d',
      width: '100%',
    },
    buttons: {
      border: '0px solid transparent',
      marginRight: '2%',
      borderRadius: '0px',
      color: Colors.secundary,
      fontWeight: 'bolder',
    },
    buttonActive: {
      marginRight: '2%',
      backgroundColor: '#e8a300',
      color: '#404040',
      fontWeight: 'bolder',
    },
    tabPaper: {
      width: "50%",
      [theme.breakpoints.down('md')]:{
        width: "auto"
      }
    }
  }),
);

export const chartWrapper = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginBottom: '1%',
      marginTop: '2%',
      width: '100%',
      backgroundColor: '#F2F2F2',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        padding: 5,
      },
    },
    flex: {
      display: 'flex',
      marginBottom: '4px',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      },
      [theme.breakpoints.down('xs')]: {
        flexWrap: 'wrap',
        width: '100%',
        padding: 0,
      },
    },
  }),
);
